import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/services/app-service.service';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {

  contactPageObj:any = {};
  contactNumber:any = {};
  address:any = {};
  constructor(private appService: AppService) { }

  ngOnInit(): void {
    this.contactPageObj = this.appService.getPageByKey('contact-page');
    this.address = this.appService.getPageByKey('address');
    this.contactNumber = this.appService.getPageByKey('contact');
  }

}
